module.exports = __webpack_public_path__ + "static/product3_2-458392fdeb3c3e02c6f7660278e68825.jpg";